<div class="appraisals-settings-container">

  <!-- Header -->
  <div class="list-header">
    <div class="header-title">
      <h3>
        <i
          class="fa fa-cog"
          aria-hidden="true"
          style="
            color: #0f766e;
            font-size: 18px;
            line-height: 1;
            margin-right: 8px;
          "
        ></i>
        <span translate>SETTINGS</span>
      </h3>
      <span class="record-count"
        >{{ totalItems }} {{ "MANAGERS" | translate }}</span
      >
    </div>
    <div class="header-actions">
      <button
        class="btn btn-success"
        (click)="openAssignManagers()"
        [disabled]="isLoadingDropdowns || !canManageManagerList"
        [attr.title]="
          !canManageManagerList
            ? ('APPRAISAL_SETTINGS_MANAGER_LIST_RESTRICTED' | translate)
            : null
        "
      >
        <i class="fa fa-user-plus" aria-hidden="true"></i>
        <span translate>ADD_MANAGERS</span>
      </button>
    </div>
  </div>

  <p class="section-helper" *ngIf="canManageManagerList" translate>
    APPRAISAL_SETTINGS_ASSIGNMENTS_HELP
  </p>
  <p class="section-helper" *ngIf="!canManageManagerList" translate>
    APPRAISAL_SETTINGS_MANAGER_LIST_RESTRICTED
  </p>

  <!-- Filters -->
  <div class="filters-section">
    <div class="row">
      <div class="col-md-3">
        <div class="form-group">
          <label translate>MANAGER</label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="managerFilter"
            (ngModelChange)="onFilterChange()"
            [placeholder]="'SEARCH' | translate"
          />
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group filter-actions">
          <label>&nbsp;</label>
          <button
            class="btn btn-outline-secondary clear-filters-btn"
            (click)="clearFilters()"
          >
            <i class="fa fa-filter" aria-hidden="true"></i>
            <span translate>CLEAR_FILTERS</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Managers table-->
  <div class="table-view">
    <p-table
      [tableStyle]="{ overflow: 'hidden' }"
      [value]="filteredManagers"
      dataKey="Id"
      [expandedRowKeys]="expandedRowKeys"
      expandableRows="true"
      [rows]="pageSize"
      [totalRecords]="totalItems"
      [paginator]="true"
      [pageLinks]="3"
      [rowsPerPageOptions]="[5, 10, 20, 50]"
      [loading]="isLoading"
    >
      <!-- Header -->
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="Name">
            {{ "NAME" | translate }}
            <p-sortIcon field="Name"></p-sortIcon>
          </th>
          <th style="width: 20%">
            {{ "ACTIVE_ASSIGNMENTS" | translate }}
          </th>
          <th style="width: 20%">
            {{ "EDIT_ASSIGNMENTS" | translate }}
          </th>
        </tr>
      </ng-template>

      <!-- Body: Managers -->
      <ng-template pTemplate="body" let-manager let-expanded="expanded">
        <tr
          [class.manager-row-locked]="isManagerLockedForCurrentUser(manager)"
          [class.current-manager-row]="isCurrentManager(manager)"
        >
          <td>
            <a (click)="toggleRow(manager, expanded)" class="btn btn-icon">
              <span
                class="fa fa-chevron-down"
                aria-hidden="true"
                *ngIf="!expanded"
              ></span>
              <span
                class="fa fa-chevron-up"
                aria-hidden="true"
                *ngIf="expanded"
              ></span>
            </a>
            <span class="manager-name-cell">
              <span>{{ manager.Name }}</span>
              <span
                *ngIf="manager.IsAdminManaged"
                class="manager-lock-chip"
                [attr.title]="'APPRAISAL_ADMIN_MANAGED_TOOLTIP' | translate"
              >
                <i class="fa fa-lock" aria-hidden="true"></i>
                <span translate>APPRAISAL_ADMIN_MANAGED_BADGE</span>
              </span>
            </span>
          </td>
          <td>{{ manager.AssignmentCount }}</td>
          <td>
            <button
              class="btn btn-primary"
              (click)="openUpdateAssignments(manager)"
              [disabled]="
                isLoadingDropdowns || isManagerLockedForCurrentUser(manager)
              "
            >
              <i class="fa fa-users" aria-hidden="true"></i>
              <span translate>EDIT_ASSIGNMENTS</span>
            </button>
          </td>
        </tr>
      </ng-template>

      <!-- Body: Employees under a manager -->
      <ng-template pTemplate="expandedrow" let-manager
        ><tr>
          <td colspan="3">
            <div *ngIf="manager.HasFetchedEmployees; else loadingAssignments">
              <p-table
                #employeeTable
                [value]="manager.FilteredEmployees"
                dataKey="EmployeeUserId"
              >
                <!-- Header -->
                <ng-template pTemplate="header">
                  <tr>
                    <th>{{ "NAME" | translate }}</th>
                    <th>{{ "DEPARTMENTS" | translate }}</th>
                    <th>{{ "STATUS" | translate }}</th>
                    <th pSortableColumn="RequestedAt">
                      {{ "REQUESTED_DATE" | translate }}
                      <p-sortIcon field="RequestedAt"></p-sortIcon>
                    </th>
                    <th pSortableColumn="RespondedAt">
                      {{ "RESPONDED_DATE" | translate }}
                      <p-sortIcon field="RespondedAt"></p-sortIcon>
                    </th>
                    <th>{{ "ASSIGNED_BY" | translate }}</th>
                  </tr>
                  <tr>
                    <th>
                      <input
                        pInputText
                        type="text"
                        (input)="
                          employeeTable.filter(
                            $event.target.value,
                            'Name',
                            'contains'
                          )
                        "
                        placeholder=""
                        class="p-column-filter"
                      />
                    </th>
                    <th></th>
                    <th>
                      <p-select
                        [options]="statusOptions"
                        optionValue="value"
                        [ngModel]="getManagerSelectedStatus(manager.Id)"
                        styleClass="p-column-filter"
                        panelStyleClass="assignment-status-filter-panel"
                        appendTo="body"
                        (onChange)="
                          onAssignedEmployeesStatusFilterChange(
                            manager,
                            $event.value
                          )
                        "
                      >
                        <ng-template let-statusOption pTemplate="selectedItem">
                          {{
                            statusOption?.labelKey || "ALL_STATUSES" | translate
                          }}
                        </ng-template>
                        <ng-template let-statusOption pTemplate="item">
                          {{ statusOption.labelKey | translate }}
                        </ng-template>
                      </p-select>
                    </th>
                    <th></th>
                    <th></th>
                    <th>
                      <input
                        pInputText
                        type="text"
                        (input)="
                          employeeTable.filter(
                            $event.target.value,
                            'AssignedBy.Name',
                            'contains'
                          )
                        "
                        placeholder=""
                        class="p-column-filter"
                      />
                    </th>
                  </tr>
                </ng-template>
                <!-- Body Content: Employees -->
                <ng-template pTemplate="body" let-employee
                  ><tr
                    class="clickable-row"
                    (click)="openEmployeePopup(employee)"
                    tabindex="0"
                    (keydown.enter)="openEmployeePopup(employee)"
                    (keydown.space)="
                      openEmployeePopup(employee); $event.preventDefault()
                    "
                  >
                    <td>{{ employee.Name }}</td>
                    <td>{{ getDepartmentsText(employee.Departments) }}</td>
                    <td>
                      {{ getStatusLabelKey(employee.Status) | translate }}
                    </td>
                    <td>{{ employee.RequestedAt | utcDate: "dd-MM-yyyy" }}</td>
                    <td>{{ employee.RespondedAt | utcDate: "dd-MM-yyyy" }}</td>
                    <td>{{ employee.AssignedBy.Name }}</td>
                  </tr></ng-template
                >
                <!-- Empty message: No assigned employees -->
                <ng-template pTemplate="emptymessage" let-columns>
                  <tr>
                    <td colspan="12">
                      {{ "NO_EMPLOYEES_ASSIGNED" | translate }}
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
            <ng-template #loadingAssignments>
              <div class="text-center p-3">
                <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
              </div>
            </ng-template>
          </td>
        </tr>
      </ng-template>
      <!-- Empty message: No managers in business -->
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td colspan="4">
            <div class="empty-state">
              <p class="empty-state-title" translate>
                APPRAISAL_EMPTY_SETTINGS_TITLE
              </p>
              <p class="empty-state-body" translate>
                APPRAISAL_EMPTY_SETTINGS_BODY
              </p>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<!-- Selected employee relationship dialog -->
<p-dialog
  [(visible)]="employeePopupVisible"
  [modal]="true"
  [draggable]="false"
  [dismissableMask]="true"
  (onHide)="selectedEmployee = null"
  [resizable]="false"
  [style]="{ width: '40rem' }"
  [header]="selectedEmployee?.Name || ('EMPLOYEE_DETAILS' | translate)"
>
  <ng-container *ngIf="selectedEmployee as e">
    <div class="p-fluid">
      <div class="p-field">
        <strong>{{ "NAME" | translate }}:</strong> {{ e.Name }}
      </div>

      <div class="p-field">
        <strong>{{ "STATUS" | translate }}:</strong>
        {{ getStatusLabelKey(e.Status) | translate }}
      </div>

      <div class="p-field">
        <strong>{{ "REQUESTED_DATE" | translate }}:</strong>
        {{ e.RequestedAt | utcDate: "dd-MM-yyyy" }}
      </div>

      <div class="p-field">
        <strong>{{ "RESPONDED_DATE" | translate }}:</strong>
        {{ e.RespondedAt | utcDate: "dd-MM-yyyy" }}
      </div>

      <div class="detail-row full">
        <strong>{{ "REJECTION_REASON" | translate }}:</strong>
        <div class="value multiline">{{ e.RejectionReason }}</div>
      </div>
    </div>
  </ng-container>
</p-dialog>

<!-- Add / Remove managers popup -->
<p-dialog
  [(visible)]="assignManagersPopupVisible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [header]="'ADD_REMOVE_MANAGERS' | translate"
  ><div class="p-fluid">
    <small class="locked-managers-note" *ngIf="!isAdminOrPortalUser">
      <i class="fa fa-lock" aria-hidden="true"></i>
      <span translate>APPRAISAL_ADMIN_MANAGED_NOTE</span>
    </small>
    <p-table
      [value]="editors"
      [(selection)]="selectedEditors"
      dataKey="Id"
      [tableStyle]="{ 'min-width': '30rem' }"
    >
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 4rem">
            <p-tableHeaderCheckbox />
          </th>
          <th>{{ "NAME" | translate }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-editor>
        <tr
          [class.locked-manager-row]="isManagerSelectionLocked(editor.Id)"
          [attr.title]="
            isManagerSelectionLocked(editor.Id)
              ? ('APPRAISAL_ADMIN_MANAGED_TOOLTIP' | translate)
              : null
          "
        >
          <td>
            <p-tableCheckbox
              [value]="editor"
              [disabled]="isManagerSelectionLocked(editor.Id)"
            />
          </td>
          <td>
            <div class="manager-name-cell">
              <span>{{ editor.Name }}</span>
              <span
                *ngIf="isManagerSelectionLocked(editor.Id)"
                class="manager-lock-chip"
                [attr.title]="'APPRAISAL_ADMIN_MANAGED_TOOLTIP' | translate"
              >
                <i class="fa fa-lock" aria-hidden="true"></i>
                <span translate>APPRAISAL_ADMIN_MANAGED_BADGE</span>
              </span>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-editor>
        <tr>
          <td colspan="4">
            {{ "NO_EDITORS_FOUND_ADD_NEW_EDITORS" | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <ng-template pTemplate="footer">
    <div class="d-grid gap-2 d-md-flex justify-content-md-end">
      <button
        type="button"
        class="btn btn-outline-primary"
        [disabled]="isSubmittingManagers"
        (click)="assignManagersPopupVisible = false"
      >
        <span translate>CANCEL</span>
      </button>
      <button
        type="button"
        class="btn btn-primary"
        [disabled]="isSubmittingManagers"
        (click)="onUpdateManagers()"
      >
        <i
          *ngIf="isSubmittingManagers"
          class="fa fa-spinner fa-spin m-r-1"
          aria-hidden="true"
        ></i>
        <span>{{
          (isSubmittingManagers ? "SAVING" : "UPDATE_MANAGERS") | translate
        }}</span>
      </button>
    </div>
  </ng-template>
</p-dialog>

<!-- Update assigned employees popup -->
<p-dialog
  [(visible)]="updateAssignmentsPopupVisible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  (onhide)="selectedManager = null"
  [header]="getUpdateAssignmentsPopupHeader()"
  ><div class="p-fluid">
    <p-table
      #assignmentsTable
      [value]="employeesWithoutCurrentManager"
      [(selection)]="selectedEmployees"
      dataKey="Id"
      [tableStyle]="{ 'min-width': '30rem' }"
      [globalFilterFields]="['Name']"
    >
      <ng-template pTemplate="caption">
        <div class="p-input-icon-left" style="width: 100%">
          <i class="pi pi-search"></i>
          <input
            pInputText
            type="text"
            style="width: 100%"
            (input)="
              assignmentsTable.filterGlobal(
                $any($event.target).value,
                'contains'
              )
            "
            [placeholder]="'SEARCH' | translate"
          />
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 4rem">
            <p-tableHeaderCheckbox />
          </th>
          <th pSortableColumn="Name">
            {{ "NAME" | translate }}
            <p-sortIcon field="Name"></p-sortIcon>
          </th>
          <th>{{ "DEPARTMENTS" | translate }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-employee>
        <tr>
          <td>
            <p-tableCheckbox [value]="employee" />
          </td>
          <td>{{ employee.Name }}</td>
          <td>{{ getDepartmentsText(employee.Departments) }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-employee>
        <tr>
          <td colspan="3">
            {{ "NO_EMPLOYEES_FOUND_ADD_NEW_EMPLOYEES" | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <ng-template pTemplate="footer">
    <div class="d-grid gap-2 d-md-flex justify-content-md-end">
      <button
        type="button"
        class="btn btn-outline-primary"
        (click)="updateAssignmentsPopupVisible = false"
        [disabled]="isSubmittingAssignments"
      >
        <span translate>CANCEL</span>
      </button>
      <button
        type="button"
        class="btn btn-primary"
        [disabled]="isLoadingAssignments || isSubmittingAssignments"
        (click)="onUpdateAssignments()"
      >
        <i
          *ngIf="isSubmittingAssignments"
          class="fa fa-spinner fa-spin m-r-1"
          aria-hidden="true"
        ></i>
        <span>{{
          (isSubmittingAssignments ? "SAVING" : "UPDATE_ASSIGNMENTS")
            | translate
        }}</span>
      </button>
    </div>
  </ng-template>
</p-dialog>

<p-confirmDialog [style]="{ width: '500px' }"></p-confirmDialog>
